<template>
  <button
    v-if="!link"
    :class="[isSuccess ? 'btn-green' : '', 'btn']"
    :disabled="isLoading"
    type="button"
  >
    <Icon v-if="icon" :icon="icon" />
    <slot v-if="!isSuccess && !isLoading" />
    <span v-if="isLoading">
      <Spinner class="white" />
    </span>
    <span v-if="isSuccess">{{ $t('common.btnSuccess') }}</span>
  </button>
  <a v-else :href="link" class="btn">
    <slot />
  </a>
</template>
<script>
import Spinner from '@/components/Spinner';
import Icon from '@/components/Icon';

export default {
  components: {
    Spinner,
    Icon
  },
  props: {
    isSuccess: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: undefined
    },
    link: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../scss/helpers/mixins';

.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  width: 100%;
  height: 45px;
  padding: 6px 12px;
  margin-bottom: 0;

  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  text-transform: none;

  touch-action: manipulation;
  cursor: pointer;
  user-select: none;
  border: 0;
  border-radius: 3px;
  transition: transform 0.42s cubic-bezier(0.165, 0.84, 0.44, 1);

  &:hover {
    transform: translateY(-5px);
  }
  &:active {
    transform: translateY(0);
  }

  .icon {
    color: $primary;
    font-size: 1.5em;
    margin-right: 0.25em;
  }

  &[disabled] {
    pointer-events: none;
    color: $dark-text;
    border: 1px solid $dark-text;
    opacity: 0.65;
  }
}
.static {
  &:hover {
    transform: none;
  }
}

.btn-primary {
  color: $primary;
  background: $white;
  border: 1px solid $primary;

  &.btn-revert {
    background: $primary;
    border: 1px solid $primary;
    color: $white;
  }

  &:hover {
    background-color: $primary;
    color: $white;
  }

  &.btn-blue {
    background: $dark-blue;
  }
  &.btn-orange {
    background: $orange;
  }
  &.btn-brown {
    background: $brown;
  }
  &.btn-green {
    background: $dark-green;
  }
  &.btn-magenta {
    background: $magenta;
  }
  &.btn-purple {
    background: $purple;
  }
  &.btn-red {
    background: $red;
  }
}

.small {
  max-width: calc(3 * 60px);
}
.big {
  max-width: calc(5 * 60px);
}

.no-border {
  border: 0;
  border-radius: 0;
}

@include breakpoint(L) {
  .btn {
    height: 50px;
  }
}
@include breakpoint(XL) {
  .btn {
    height: 60px;
  }
}
.dot {
  border-radius: 100%;
  padding: 0;
  width: 15px;
  height: 15px;
}

.label-left {
  justify-content: flex-start;
}
</style>
